module.exports = __webpack_public_path__ + "media/assets/icons/close-outline-a7df45207b7c0c71e312122ff678aa95.svg";